import Dexie, { Table } from 'dexie';

export type FieldEntityType =
  | 'task'
  | 'task_status_event'
  | 'qc_template'
  | 'qc_run'
  | 'qc_checklist_item_result'
  | 'defect'
  | 'defect_status_event'
  | 'daily_field_report'
  | 'dfr_entry'
  | 'timesheet'
  | 'timesheet_entry'
  | 'attendance_record'
  | 'field_evidence'
  | 'unit'
  | 'component'
  | 'team'
  | 'worker';

export type FieldOutboxStatus = 'pending' | 'syncing' | 'synced' | 'conflict' | 'failed';

export interface FieldCacheRecord<T = unknown> {
  key: string;
  entityType: FieldEntityType;
  entityId: string;
  projectId?: string | null;
  userId?: string | null;
  payload: T;
  serverUpdatedAt?: string | null;
  cachedAt: string;
}

export interface FieldOutboxAction<T = unknown> {
  id?: number;
  clientUuid: string;
  entityType: FieldEntityType;
  entityId?: string | null;
  actionType: string;
  projectId?: string | null;
  payload: T;
  baseVersionAt?: string | null;
  status: FieldOutboxStatus;
  attemptCount: number;
  errorMessage?: string | null;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string | null;
}

export interface FieldSyncMetadata {
  key: string;
  value: string;
  updatedAt: string;
}

class FieldOfflineDatabase extends Dexie {
  fieldCache!: Table<FieldCacheRecord, string>;
  fieldOutbox!: Table<FieldOutboxAction, number>;
  syncMetadata!: Table<FieldSyncMetadata, string>;

  constructor() {
    super('fairmont_field_mode');

    this.version(1).stores({
      fieldCache: '&key, entityType, entityId, projectId, userId, cachedAt',
      fieldOutbox: '++id, &clientUuid, status, entityType, projectId, createdAt, updatedAt',
      syncMetadata: '&key',
    });
  }
}

export const fieldDb = new FieldOfflineDatabase();

export const fieldOfflineStoreNames = ['fieldCache', 'fieldOutbox', 'syncMetadata'] as const;
